
window.addEventListener( 'load', function() {
    if ( 'serviceWorker' in navigator ) {
        let _base = document.location.href.split('/');
        _base.pop();
        let _swurl = _base.join( '/' ) + '/serviceworker.js.php';
        navigator.serviceWorker.getRegistrations().then( registrations => {
            let _registered = false;
            for ( let registration of registrations ) {
                if ( registration.active.scriptURL != _swurl ) {
                    registration.unregister();
                    console.info( 'ServiceWorker removido: ', registration.active.scriptURL );
                } else {
                    _registered = true;
                    console.info( 'ServiceWorker já registrado: ', registration.active.scriptURL );
                }
            }
            if ( !_registered ) {
                navigator.serviceWorker.register( _swurl ).then( function( registration ) {
                    console.info( 'ServiceWorker ' + _swurl + ' registrado no escopo: ', registration.scope );
                } ).catch( function( err ) {
                    console.info( 'Falha no registro do ServiceWorker', err );
                } );
            }
        } );
    }
} );